import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import { pmsSourceNames } from '../MoveDialog/MoveDialog'
import styles from './DeleteDialog.module.scss'

function DeleteLogsDialog({ onClose, logs, selectedRows, month, year }) {
  const { addToast } = useToasts()

  const allLogs = logs.flatMap(entry => entry.logs.flatMap(log => log.logs))
  const selectedLogs = allLogs.filter(log => selectedRows.includes(log.id))
  const currentHotel = useSelector(s => s.hotelDetails)

  const [loading, setLoading] = useState(false)

  const onConfirm = async () => {
    setLoading(true)
    pmsApi
      .deleteLogs({
        histories: selectedLogs.map(log => ({ id: log.id, reportKind: log.reportKind })),
        originSubsidiaryId: currentHotel.subsidiaryId,
        month: month,
        year: year
      })
      .then(() => {
        addToast('PMS histories deleted successfully', {
          appearance: 'success',
          autoDismiss: true
        })
      })
      .catch(err =>
        addToast(`Something went wrong while deleting pms histories: ${err.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      )
      .finally(() => {
        setTimeout(() => {
          onClose()
          setLoading(false)
        }, 2000)
      })
  }

  return (
    <ConfirmationDialog
      hasDangerousAction
      hasCloseButton
      hasConfirmButton
      negativeMessage="Cancel"
      positiveMessage="Confirm and start the process"
      contentAbove={
        <div className={styles.contentAboveContainer}>
          <i className={styles.warningIcon} />
          <p className={styles.warningText}>
            Pay attention! This process may have severe consequences and cannot be
            reversed.
          </p>
        </div>
      }
      title="Are you sure?"
      onClose={onClose}
      onReject={onClose}
      onConfirm={onConfirm}
      contentPadding="0"
      isButtonDisabled={loading}
    >
      {selectedLogs.map((row, index) => (
        <div key={index} className={styles.row}>
          <div className={styles.uploadedByCol}>
            <i className={styles[row.pmsSource]} />
            {row.pmsSource === 'Email'
              ? row.pmsEmail ?? '-'
              : pmsSourceNames[row.pmsSource]}
          </div>

          <div className={styles.subRow}>
            <div className={styles.iconCol}>
              <i className={styles.calendarIcon} />
              {row.numberOfTotalRecords}
            </div>

            <div className={styles.iconCol}>
              <i className={styles.userIcon} />
              {row.numberOfNewSubscribers}
            </div>
          </div>

          <div className={styles.statusCol}>
            <p className={styles.title}>Recieved</p>
            <p className={styles.subTitle}>
              {moment(row.uploadedOn).format('MMM DD, hh:mm A')}
            </p>
          </div>
        </div>
      ))}

      <p className={styles.confirmationText}>
        I confirm records {mergeStrings(selectedLogs.map(i => '#' + i.id))} and all
        related guest and booking data to be deleted from #{currentHotel.displayId}{' '}
        {currentHotel.name}.
      </p>
    </ConfirmationDialog>
  )
}

export default DeleteLogsDialog

function mergeStrings(strings) {
  if (strings.length === 0) return ''
  if (strings.length === 1) return strings[0]
  return `${strings.slice(0, -1).join(', ')} and ${strings[strings.length - 1]}`
}
